import type { ScheduledConsultationDTO } from '@/generated'
import { useScheduledConsultationRequest } from '@/composables/useScheduledConsultationRequest'
import { useI18n } from 'vue-i18n'
import { ActionType } from '@/enums/ActionType'
import { computed } from 'vue'

interface Action {
  actionType: ActionType
  actionName: string
  actionCallback: () => Promise<void>
}

function useScheduledConsultationActions(consultation: ScheduledConsultationDTO) {
  const { acceptScheduledConsultationById, declineScheduledConsultationById } =
    useScheduledConsultationRequest(consultation)

  const { t } = useI18n()

  const consultationActions = computed<Action[]>(() => [
    {
      actionType: ActionType.DECLINE,
      actionName: t('Decline'),
      actionCallback: () => declineScheduledConsultationById(consultation.id)
    },
    {
      actionType: ActionType.START_CALL,
      actionName: t('Accept'),
      actionCallback: () => acceptScheduledConsultationById(consultation.id)
    }
  ])

  return { consultationActions }
}

export default useScheduledConsultationActions
